'use client';
import { useState, useEffect, useRef } from 'react';
import Logo from '@/components/ui/Logo';
import Skip from '@/components/ui/Skip';
import Icon from '@/components/ui/Icon';
import Menu from '@/components/ui/Menu';
import Nav from '@/components/global/Nav';
import '@/styles/components/global/header.css';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) setIsScrolled(window.scrollY > headerRef.current.offsetHeight);
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  useEffect(() => {
    document.body.classList.toggle('scrolled', isScrolled);
  }, [isScrolled]);

  return (
    <header ref={headerRef}  id="header-main" className="header-main">
      <Logo title="Empire Nine Digital" />
      <Skip />
      <Icon alt="E9" />
      <Menu />
      <Nav />
    </header>
  )
}
